import * as React from 'react';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';

export interface DeleteOmbudButtonProps {
  isActive?: boolean;
  modalHeading: string;
  modalBody: string;
  cancelText: string;
  actionText: string;
  disabled: boolean;
  postLink: string;
  buttonRemoveText?: string;
  buttonCssClass?: string;
}

export interface DeleteOmbudButtonState {
  isModalOpen: boolean;
}

export class DeleteOmbudButton extends React.Component<DeleteOmbudButtonProps, DeleteOmbudButtonState> {
  static defaultProps = {
    buttonCssClass: '',
  };
  constructor(props: DeleteOmbudButtonProps) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  doDelete = () => {
    this.closeConfirm();
  };

  openConfirm = (e: React.MouseEvent) => {
    e.preventDefault();

    this.setState({
      isModalOpen: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  public render() {
    const { isModalOpen } = this.state;
    const { modalHeading, modalBody, cancelText, buttonRemoveText, actionText, disabled, postLink, buttonCssClass } =
      this.props;

    return (
      <div className="eservicemenu">
        <button onClick={this.openConfirm} disabled={disabled} className={`stripped-button ${buttonCssClass}`}>
          {buttonRemoveText ? buttonRemoveText : 'Ta bort'}
          <Icon iconType="Paperbin" />
        </button>

        <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
          <button onClick={this.closeConfirm} className="close">
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>
          <div className="header">
            <h2>{modalHeading}</h2>
          </div>
          <p>{modalBody}</p>
          <div className="footer">
            <button className="button button--white" onClick={this.closeConfirm}>
              {cancelText}
            </button>
            <form action={postLink} method="post">
              <input type="submit" className="button button--red" value={actionText} />
            </form>
          </div>
        </Dialog>
      </div>
    );
  }
}
